import { mapGetters, mapActions } from 'vuex'
import help from '@/utils/help'
import manuscript from '@/api/manuscript'
import { settingCountry } from '@/api/setting'
import check from '@/utils/check'

export default {
  data() {
    return {
      firstIndex: '',
      authorIndex: '',
      editData: {
        affiliations: [''],
        affiliation: '',
        submited: false,
        firsted: false,
        corresponded: false,
      },
      editItem: '',
      firstList: [],
      authorList: [],
      rules: {},
      countryList: [],
      manuscriptConfirm: false,
      authorconfirm: false,
      orderConfirm: false,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      country: 'getCountry',
      title: 'getTitle',
      manuscript: 'getManuscript',
      user: 'getUser',
    }),
  },
  watch: {
    manuscript: {
      handler(val) {
        if (val.id) {
          let { authorList } = val
          authorList = authorList || []
          this.firstList = []
          this.authorList = []
          if (authorList.length) {
            authorList.forEach((item) => {
              if (item.firsted) {
                this.firstList.push(item)
              } else {
                this.authorList.push(item)
              }
            })
            setTimeout(() => {
              if (this.firstList.length) {
                this.edit(this.firstList[0], 0)
              } else {
                this.edit(this.authorList[0], 0)
              }
            }, 0)
          } else {
            const {
              firstName,
              lastName,
              titleCode,
              email,
              countryCode,
              orcid,
              affiliation,
            } = this.user
            this.authorList.push(
              JSON.parse(
                JSON.stringify({
                  firstName,
                  lastName,
                  titleCode,
                  email,
                  countryCode,
                  orcid,
                  affiliation: affiliation || '',
                  affiliations: affiliation ? affiliation.split(';') : '',
                  submited: true,
                  firsted: false,
                  corresponded: true,
                })
              )
            )
            this.edit(this.authorList[0], 0)
            // this.editItem = this.firstList[0]
            // this.addNewAuthor()
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getRules()
    this.countrySearch()
  },
  methods: {
    ...mapActions(['updateManuscript']),
    async submit() {
      let flag = false
      if (
        this.firstIndex ||
        this.firstIndex === 0 ||
        this.authorIndex ||
        this.authorIndex === 0
      ) {
        flag = this.editItem
          ? this.editItem.firsted
            ? this.save(this.editItem, this.firstIndex)
            : this.save(this.editItem, this.authorIndex)
          : this.save(this.editItem, this.authorIndex)
      }
      if (flag) {
        return
      }
      const { id, sign, version } = this.manuscript
      const data = {
        id,
        sign,
        version,
        authorList: [],
      }
      this.firstList.forEach((item, index) => {
        item.sort = index
        item.seq = 1
        data.authorList.push(item)
      })
      this.authorList.forEach((item, index) => {
        item.sort = (this.firstList ? this.firstList.length : 0) + index
        item.seq = index + 2
        data.authorList.push(item)
      })
      const res = await manuscript.step2(data)

      this.updateManuscript(res)
      this.$router.push('step3?id=' + res.id)
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val,
      })
    },
    addAff() {
      this.editData.affiliations.push('')
    },
    delAff(index) {
      if (this.editData.affiliations.length === 1) {
        return
      }
      this.editData.affiliations.splice(index, 1)
    },
    getAff() {
      const arr = []
      this.editData.affiliations.forEach((item) => {
        if (item) {
          arr.push(item)
        }
      })
      this.editData.affiliation = arr.join(';')
    },
    edit(record, index) {
      let flag = false
      if (
        this.firstIndex ||
        this.firstIndex === 0 ||
        this.authorIndex ||
        this.authorIndex === 0
      ) {
        flag = this.editItem
          ? this.editItem.firsted
            ? this.save(this.editItem, this.firstIndex)
            : this.save(this.editItem, this.authorIndex)
          : this.save(this.editItem, this.authorIndex)
      }
      if (flag) {
        return
      }
      if (flag !== false && record.firsted !== this.editData.firsted) {
        index -= 1
      }
      if (record.firsted) {
        // console.log(index, 'index', typeof index)
        this.firstIndex = index
      } else {
        this.authorIndex = index
      }
      this.editData = JSON.parse(JSON.stringify(record))
      this.editItem = record
      this.editData.edit = true
      this.editData.affiliations = this.$set(
        this.editData,
        'affiliations',
        this.editData.affiliation ? this.editData.affiliation.split(';') : []
      )
    },
    del(record, index) {
      if (
        this.firstIndex ||
        this.firstIndex === 0 ||
        this.authorIndex ||
        this.authorIndex === 0
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please save the content you are editing first！',
        })
        return
      }

      this.$confirm({
        title: 'Are you sure you want to delete this author?',
        content:
          'Please be aware of once this author is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        if (record.firsted) {
          this.firstList.splice(index, 1)
        } else {
          this.authorList.splice(index, 1)
        }
        this.$message.success({
          title: 'Success',
          content: 'This author has been deleted!',
        })
      })
    },
    save(record, index) {
      // let emailArr = []
      const re = `author-edit-form${index}`
      const flag = this.$refs[re][0].validate()
      if (this.check(this.editData)) {
        record.firsted
          ? this.firstList.splice(index, 1)
          : this.authorList.splice(index, 1)
        this.authorIndex = ''
        this.firstIndex = ''
        this.editItem = ''
        return
      }
      if (flag) {
        // let f = this.firstList.some((item, i) => {
        //   if (item.email === this.editData.email && index !== i) {
        //     return true
        //   }
        // })
        // if (!f) {
        //   f = this.authorList.some((item, i) => {
        //     if (item.email === this.editData.email && index !== i) {
        //       return true
        //     }
        //   })
        // }
        // if (index === 0) {
        //   emailArr = this.authorList
        //     .map(item => item.email)
        //     .concat(this.firstList.map(item => item.email))
        //   f = emailArr.includes(this.editData.email)
        // }
        // // console.log(emailArr, 'emailArr')
        // if (f) {
        //   this.$message.error({
        //     title: 'Error',
        //     content: `The author's mailbox already exists in the author list`
        //   })
        //   return
        // }
        let flag
        if (!record || record.firsted === this.editData.firsted) {
          flag = false
          record.firsted
            ? this.$set(this.firstList, index, this.editData)
            : this.$set(this.authorList, index, this.editData)
        } else {
          if (!this.editData.firsted) {
            this.firstList.splice(index, 1)
            this.$set(this.authorList, this.authorList.length, this.editData)
          } else {
            this.authorList.splice(index, 1)
            this.$set(this.firstList, this.firstList.length, this.editData)
          }
        }
        this.authorIndex = ''
        this.firstIndex = ''
        this.editItem = ''
        return flag
      } else {
        return true
      }
    },
    cancel(index) {
      if (!this.editData.edit) {
        this.authorList.splice(index, 1)
      }
      this.firstIndex = ''
      this.authorIndex = ''
      this.editItem = ''
    },
    check(data) {
      if (
        !data.titleCode &&
        !data.firstName &&
        !data.lastName &&
        !data.email &&
        !data.countryCode &&
        !data.orcid &&
        !data.affiliation
      ) {
        return true
      }
      return false
    },
    addNewAuthor() {
      let flag = false
      if (
        this.firstIndex ||
        this.firstIndex === 0 ||
        this.authorIndex ||
        this.authorIndex === 0
      ) {
        // console.log(this.editItem, 'iii')
        flag = this.editItem
          ? this.editItem.firsted
            ? this.save(this.editItem, this.firstIndex)
            : this.save(this.editItem, this.authorIndex)
          : this.save(this.editItem, this.authorIndex)
      }
      if (flag) {
        return
      }
      this.editData = {
        affiliations: [''],
        affiliation: '',
        submited: false,
        firsted: false,
        corresponded: false,
      }
      this.authorIndex = this.authorList.length
      this.authorList.push(JSON.parse(JSON.stringify(this.editData)))
      const re = `author-edit-form${this.authorIndex}`
      this.$nextTick(() => {
        const h = help.getElementTop(this.$refs[re][0].$el)
        document.documentElement.scrollTop = document.body.scrollTop = h
      })
    },
    setSort(index, val, el) {
      if (
        this.firstIndex ||
        this.firstIndex === 0 ||
        this.authorIndex ||
        this.authorIndex === 0
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Please save the content you are editing first！',
        })
        return
      }
      const temp = this[el][index]
      const temp2 = this[el][index + val]
      this.$set(this[el], index + val, temp)
      this.$set(this[el], index, temp2)
    },
    checkEmail(val) {
      const emailArr = this.authorList
        .map((item) => item.email)
        .concat(this.firstList.map((item) => item.email))
      if (
        this.firstIndex !== '' &&
        (!this.firstList[this.firstIndex].email ||
          this.firstList[this.firstIndex].email !== this.editData.email)
      ) {
        emailArr.push(this.editData.email)
      }
      if (
        this.authorIndex !== '' &&
        (!this.authorList[this.authorIndex].email ||
          this.authorList[this.authorIndex].email !== this.editData.email)
      ) {
        emailArr.push(this.editData.email)
      }
      let flag = 0
      emailArr.forEach((item) => {
        if (item === val) {
          flag++
        }
      })
      return flag <= 1
    },
    checkOrcid(val) {
      const exg1 = /^(([0-9]{4,4})-){3,3}[0-9]{4,4}\b$/
      const exg2 = /^[0-9]{16,16}$/
      // console.log(val.match(exg1), '校验', val.match(exg2))
      if (!val) {
        return true
      }
      if (val.match(exg1) || val.match(exg2)) {
        return true
      } else {
        return false
      }
    },
    back() {
      const path = this.$route.fullPath.replace('step2', 'step1')
      this.$router.push(path)
    },
    getRules() {
      this.rules = {
        titleCode: [
          {
            required: true,
            message: 'Title' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        orcid: [
          {
            fun: check.orcid,
            message: `Please input right ORCID number.`,
          },
        ],
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email',
          },
          {
            fun: this.checkEmail,
            message: `The author's mailbox already exists in the author list`,
          },
        ],
        countryCode: [
          {
            required: true,
            message: 'Country' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        affiliation: [
          {
            required: true,
            message: 'Affiliations' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
      }
    },
  },
}
